import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';
import type {
  CampaignStatsResponse,
  UserCampaignProgress,
  TriggerManualEmailResponse
} from 'types/interfaces/dripCampaign';
import { MessageType } from 'types/interfaces/message';

export const dripCampaignApi = createApi({
  reducerPath: 'dripCampaignApi',
  baseQuery: baseQuery,
  tagTypes: ['CampaignStats', 'UserProgress'],
  endpoints: (builder) => ({
    getCampaignStats: builder.query<CampaignStatsResponse, void>({
      query: () => ({
        url: '/admin/drip-campaign/stats',
        method: 'GET',
        requiresAuth: true,
      }),
      providesTags: ['CampaignStats'],
    }),

    getUserProgress: builder.query<UserCampaignProgress, number>({
      query: (userId) => ({
        url: `/admin/drip-campaign/users/${userId}/progress`,
        method: 'GET',
        requiresAuth: true,
      }),
      providesTags: (_result, _error, userId) => [{ type: 'UserProgress', id: userId }],
    }),

    triggerManualEmail: builder.mutation<
      TriggerManualEmailResponse,
      { userId: number; messageType: MessageType }
    >({
      query: ({ userId, messageType }) => ({
        url: `/admin/drip-campaign/trigger/${userId}/${messageType}`,
        method: 'POST',
        requiresAuth: true,
      }),
      invalidatesTags: (_result, _error, { userId }) => [
        'CampaignStats',
        { type: 'UserProgress', id: userId }
      ],
    }),
  }),
});

export const {
  useGetCampaignStatsQuery,
  useGetUserProgressQuery,
  useTriggerManualEmailMutation,
} = dripCampaignApi;
